import { Loader2 } from 'lucide-react';
import { CompactDateRangePicker, CompactDomainSelect, CompactProjectSelect } from '@/pages/Dashboard';
import type { Domain } from '@/types/domain';
import { NAV_MAX_RANGE_DAYS, type NavigationFiltersState } from '../hooks/useNavigationFilters';

interface FiltersProps {
    state: NavigationFiltersState;
    projects: Array<{ id: number; name: string }> | undefined;
    isOwner: boolean;
    /** Domínios já recortados pelos projetos selecionados. */
    domains: Domain[] | undefined;
    /** Trava a barra enquanto uma request roda. */
    busy?: boolean;
}

/** Barra de filtros (padrão visual MetaFlow/Anunciantes): projetos, domínios e período numa linha que quebra. */
export function Filters({ state, projects, isOwner, domains, busy }: FiltersProps) {
    return (
        <div className="flex flex-col items-stretch gap-2 rounded-lg border border-border bg-card p-2 sm:flex-row sm:flex-wrap sm:items-center md:gap-3 md:p-3">
            <div
                className={`flex flex-col items-stretch gap-2 sm:flex-row sm:flex-wrap sm:items-center md:gap-3 ${
                    busy ? 'pointer-events-none opacity-50' : ''
                }`}
                aria-busy={busy}
            >
                <CompactProjectSelect multiple value={state.projectIds} onChange={state.setProjectIds} projects={projects} isOwner={isOwner} />
                <CompactDomainSelect value={state.domains} onChange={state.setDomains} domains={domains} />
                <div className="hidden h-6 w-px bg-border lg:block" />
                <CompactDateRangePicker
                    startDate={state.startDate}
                    endDate={state.endDate}
                    onDateChange={state.setDates}
                    include15Days
                    maxRangeDays={NAV_MAX_RANGE_DAYS}
                />
            </div>
            {busy && (
                <span className="flex items-center gap-1.5 text-[11px] text-muted-foreground sm:ml-auto">
                    <Loader2 className="h-3.5 w-3.5 animate-spin" />
                    carregando — filtros travados
                </span>
            )}
        </div>
    );
}
